const en = {
  action: {
    label: "Ação | Ações",
    add: "Adicionar",
    added_in_enabled: "+ Ativos",
    added_in_disabled: "+ Excluídos",
    add_new: "Adicionar Novo | Adicionar Novos",
    add_new_language: "Adicionar Idioma | Adicionar Idiomas",
    all_profiles: "Todos os Perfis",
    archive: "Arquivar",
    update_avatar: "Atualizar Avatar",
    category: "Categoria | Categorias",
    change: "Alterar",
    comment: "Comentar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    compare: "Comparar",
    compare_ratings: "Comparar Avaliação | Comparar Avaliações",
    compare_average_ratings:
      "Comparar Média das Avaliações | Comparar Média das Avaliações",
    copy: "Copiar",
    copy_url: "Copiar Url",
    create_account: "Criar Conta",
    create_your_resume: "Crie seu Currículo",
    create_free_account: "Criar Conta FREE",
    create_new_process: "Criar novo process",
    created: "Registrado",
    close: "Fechar",
    close_process: "Fechar processo",
    delete: "Excluir",
    disable: "Desabilitar",
    end: "Terminar",
    edit: "Editar",
    edit_user: "Editar Usuário",
    edit_product: "Editar Produto | Editar Produtos",
    enable: "Habilitar",
    generate_link: "Gerar Link",
    generate_new_link: "Gerar Novo Link",
    filter: "Filtrar",
    following: "Seguindo",
    inactive: "Desativa",
    active: "Ativar",
    include: "Incluir",
    insert: "Inserir",
    insert_new: "Inserir New",
    move: "Mover",
    new_profile: "Novo Perfil",
    new_process: "Novo Processo",
    open: "Abrir",
    print: "Imprimir",
    profile_added: "Perfil Adicionado | Perfis Adicionados",
    ready_more: "Leia Mais",
    register: "Registrar",
    register_financial_record:
      "Registrar Movimentação Financeira | Registrar Movimentações Financeiras",
    remove: "Remover",
    remember: "Lembrar",
    reload: "Recarregar",
    start: "Começar",
    show: "Exibir",
    show_in_menu: "Mostrar no menu principal",
    show_detail: "Exibir Detalhe | Exibir Detalhes",
    send: "Enviar",
    select_file: "Selecionar Arquivo | Selecionar Arquivos",
    stock_in: "Entrada de Estoque",
    select: "Selecionar",
    select_image: "Selecionar Imagem | Selecionar Imagens",
    search: "Buscar",
    stock_out: "Saída de Estoque",
    save: "Salvar",
    saved: "Registrado | Registrados",
    save_and_select: "Salvar e Selecionar",
    register_new: "Registrar Novo",
    signup: "Registrar-me",
    signin: "Login",
    submit: "Submeter",
    upload: "Upload",
    unselect: "Remover Seleção",
    back: "Voltar",
    update: "Atualizar",
    unarchive: "Desarquivar",
    use: "Usar",
  },
  address: {
    label: "Endereço | Endereços",
    street: "Rua | Ruas",
    number: "Número | Números",
    city: "Cidade | Cidades",
    district: "Bairros | Bairros",
    state: "Estado | Estados",
    country: "País | Países",
    complement: "Morada | Moradas",
    zip_code: "Caixa Postal | Caixas Postais",
  },
  average_rating: "Média da Avaliação | Médias das Avaliações",
  all_my_tasks: "Todas as minhas tarefas",
  all_my_open_task:
    "Todas as minhas tarefas em aberto | Todas as minhas tarefas em aberto",
  archived: "Arquivado | Arquivados",
  account: "Conta | Contas",
  all: "Todos",
  all_processes: "Todos Processos",
  all_profiles: "Todos Perfis",
  avatar: "Avatar | Avatars",
  academic: "Acadêmico | Acadêmicos",
  access_restriction: "Restrição de Acesso | Restrições de Acesso",
  evaluation_topic: "Tópico de Avaliação | Tópicos de Avaliação",
  evaluation_result: "Resultado de Avaliação | Resultados de Avaliação",
  amount: "Quantidade | Quantidade",
  best: "Melhor | Melhores",
  by_profile_owner:
    "Mantido pelo usuário dono do perfil | Mantidos pelo dono do perfil",
  barcode: "Código de Barras | Códigos de Barras",
  best_up: "Melhor Mais | Melhor Mais",
  best_down: "Melhor Menos | Melhor Menos",
  basic_data: "Dados Básico | Dados Básicos",
  billing_email: "E-mail de Cobrança | E-mails de Cobrança",
  business_name: "Nome Fantasia | Nome Fantasia",
  boolean: {
    yes: "Sim",
    no: "Não",
  },
  candidate: "Candidato | Candidatos",
  closed_process: "Processo Fechado | Processos Fechados",
  closed: "Fechado | Fechados",
  created_by: "Criado por",
  created_date: "Data de criação",
  cv: "Currículo | Currículos",
  curriculum_vitae: "Curriculum Vitae | Curriculum Vitae",
  color: "Cor | Cors",
  customer: {
    label: "Cliente | Clientes",
    name: "Nome do Cliente| Nomes dos Clientes",
    main_name: "Nome principal do cliente",
    code: "Código do Cliente | Códigos dos Clientes",
    contact: "Contato do Cliente | Contatos dos Clientes",
  },
  custom_features: "Recurso sob medida | Recursos sob medida",
  curriculum: "Curriculum | curriculums",
  compare_profile: {
    label: "Compare Perfis",
    desc:
      "Defina os critérios de avaliação dos perfis e compare os resultados.",
    ai: {
      title: "IA",
      desc:
        "Use o poder <strong>inteligência artificial</strong> para obter análises de avaliações de perfis conforme critérios específicos e editáveis, seja em processos seletivos de candidatos, cotações de fornecedores ou qualquer outro tipo de processo que desejar.",
      desc_hiring:
        "Use o poder <strong>inteligência artificial</strong> para obter análises de avaliações de perfis conforme critérios específicos e editáveis, seja em processos seletivos de candidatos, cotações de fornecedores ou qualquer outro tipo de processo que desejar.",
    },
  },
  competency_dossier: "Dossiê de Competências | Dossiês de Competências",
  current_period: "Período Corrente",
  core: "Core | Cores",
  core_skill: "Core Skill | Core Skills",
  core_skill_not: "Não é Habilitação Principal | Não é Habilitações Principais",
  code: "Código | Códigos",
  cost: "Custo | Custos",
  context: "Contexto | Contextos",
  country: "País | Países",
  company: "Empresa | Empresas",
  company_name: "Nome da Empresa | Nome das Empresas ",
  certification: "Certificado | Certificados",
  city: "Cidade | Cidades",
  current: "Atual | Atuais",
  custom_label: "Personalizado | Personalizados",
  confirmed: "Confirmado | Confirmado",
  canceled: "Cancelado",
  currency: {
    label: "Moeda | Moedas",
    euro: "Euro | Euros",
    dollar: "Dolar| Dolars",
    pound: "Pound | Pounds",
    real: "Real | Reais",
  },
  content: "Conteúdo | Conteúdos",
  no_content: "Sem conteúdo. | Sem conteúdo.",
  closing_date: "Data de Fechamento| Datas de Fechamento",
  closed_data: "Data de Fechamento| Datas de Fechamento",
  closed_with_delay: "Fechado com Atraso",
  closed_with_delay_explanation: "Processo fechado após o prazo",
  closed_in_time: "Fechado em Tempo",
  closed_in_time_explanation: "Processo fechado antes do prazo",
  contact: {
    label: "Contato | Contatos",
    request_contact: "Pedir Contato",
    send_your_msn: "Mande sua mensagem",
    any_questions: `Alguma questão ou dúvida?
						Mande agora uma mensagem.`,
    suporte_contact: "Contato de suporte",
    if_prefer_send_email: `Se preferir, envie um e-mail para nosso suporte`,
    menssage_sent: 'Mensagem enviada',
		we_will_response_soon: 'Responderemos em breve.',
  },
  done: "Finalizado | Finalizados",
  delete_account: {
    label: "Excluir Conta e Perfil",
    text: `Para excluir sua conta e perfil, envie um mensagem
            para <b>{email}</b> com sua solicitação.`,
  },
  disabled: "Desablitado | Desablitados",
  description: "Descrição | Descrições",
  deleted: "Excluído | Excluídos",
  default: "Padrão | Padrões",
  default_label: "Rótulo Padrão | Rótulos Padrão",
  derived_process: "Processo Derivado | Processos Derivados",
  discount: "Desconto | Descontos",
  down: "Baixo",
  developed_projects: "Projeto Desenvolvido | Projetos Desenvolvidos",
  dashboard: "Painel de Controle",
  deadline: "Prazo | Prazos",
  data: "Data | Datas",
  date: {
    start_day: "Dia Inicial",
    end_day: "Dia Final",
    label: "Data | Datas",
    due_date: "Vencimento | Vencimentoa",
    paid_date: "Data Pagamento | Data Pagamentos",
    by: "Data por | Data por",
    date_range: "Período | Períodos",
    year: "Ano | Anos",
    birth: "Aniversário | Aniversários",
    birth_day: "Data de Nascimento | Datas de Nascimento",
    birthday: "Data de Nascimento | Datas de Nascimento",
    today: "Hoje",
    last_week: "1 Semana | {n} Semanas",
    last_month: "1 Mês | {n} Meses",
    last_year: "1 Ano | {n} Anos",
    one_week: "1 Semana",
    one_month: "1 Mês",
    one_year: "1 Ano",
    month: {
      label: "Mês | Meses",
      by_number: {
        short: {
          1: "Jan",
          2: "Fev",
          3: "Mar",
          4: "Abr",
          5: "Maio",
          6: "Jun",
          7: "Jul",
          8: "Ago",
          9: "Set",
          10: "Out",
          11: "Nov",
          12: "Dez",
        },
      },
    },
  },
  document_model: "Modelo de Documento | Modelos de Documentos",
  specific_period: "Específico Período | Específico Períodos",
  enabled: "Habilitado | Habilitados",
  extract: "Extrato | Extratos",
  exception: "Exception | Exceptions",
  experience: "Experiência | Experiências",
  external_link: {
    label: "Link Externo | Links Externo",
    message: {
      confirm_delete_link: "O link será excluído permanentemente. Confirmar?",
      explain_in_process: `O usuários externos registradados pelo link abaixo,
								terá automaticamente seu perfil
								associado com o processo atual.<br/>
								Usuários administrativos associados com
								este processo receberão avisos para cada
								novo perfil registrado através
								com o link. |
								Os usuários externos registrados pelo link abaixo,
								terão automaticamente seus perfis
								associados com o processo atual. <br/>
								Usuários administrativos associados com
								este processo receberão avisos para cada
								novo perfil registrado através
								do link.`,
      explain_in_profile: `Links externos podem ser comprartilhados com outras pessoas para registrarem
								perfis diretamente na sua conta.<br>
                Sempre que alguém criar um novo perfil na sua conta, você será notificado.<br>
                Compartilhe o link em redes sociais, no seu
                site corporativo, por e-mail ou onde desejar.<br><br>
                <strong>
                <a href="/#/admin/profile_types">
                <u>
                Para definir e manter atualizadas as políticas de privacidade e
                termos de uso, acesse as configurações do tipo de perfil
                correspondente. Acesse Aqui
                </u>
                <a></strong>`,
      change_terms_in_profile_settings: `Para definir e atualizar os Termos e Políticas de uso
                que devem ser aceitos pelos donos dos perfis, acesse as
                configurações específicas do tipo de perfil.
                <br><br> Como o registro não está a ser atualizado pelo
                próprio dono do perfil, é indicado guardar provas de que o mesmo
                concordou com os termos expressos. Quando você indica no cadastro de um perfil de outra
                pessoa que aceita os termos, está, na verdade, afirmando que o dono do perfil está de acordo.<br><br>
                Verifique e respeite a legislação vigente em seu país relativa à proteção de dados.
                Se não estiver seguro sobre essa legislação, procure orientação jurídica adequada antes de registrar
                perfis de terceiros.
                `,
    },
  },
  experience_years: "Sem Experiência | {years} ano | {years} anos",
  email: "E-mail | E-mails",
  education: "Educação | Educação",
  expense: "Despesa | Despesas",
  end: "Fim | Finais",
  end_date: "Data Fim | Datas Fim",
  error: {
    label: "Erro",
    file_too_big: "Tamanho máximo permitido de 1mb",
    sending_data: "Erro ao enviar os dados",
    generic: "Ocorreu um erro. Cod. {code}",
    item_is_required: "{item}: É necessário.",
    comment_something: "Comment Algo",
    user_not_confirmed_email_sent: `Email não confirmado. Uma mensagem de
      confirmação foi enviada novamente. Por favor, acesse o link na mensagem.`,
  },
  profile_bank: "Banco de Currículos | Bancos de Currículos ",
  profile_rules: {
    allow_use_profile_any_process: "Permitir usar perfis em qualquer processo",
    expire_profile: "Perfil Expirado",
    not_expire: "Não Expirado",
    only_on_process: "Apenas um processo",
    after_end_processes: "Depois de finalizar processos",
    after_n_months: "Após 1 mês | Após {n} meses",
    allow_internal_share: "Permitir compartilhamento interno",
    only_internal_information: {
      label: "Informação apenas de uso interno",
      explanation: "Visível apenas para administradores da conta.",
    },
    allow_external_share: "Permitir compartilhamento externo",
    is_privacy_policy: "É política de privacidade",
    contact: {
      registered_process: "Permite contato para processos vinculados.",
      other_process: "Permite contato para todos os processos.",
    },
    accept_by_other_user: `A comprovação da aceitação dos termos e políticas
			e de suas condições, quando o registro não é feito pelo
			proprietário do perfil, é de responsabilidade
			do utilizador que realizou o cadastro e do responsável pela conta e não
			da ProcessFlex.
			<br>
			Dica: Anexe arquivos comprovativos da aceitação do cadastro.<br>`,
  },
  from: "De",
  free_support_and_training: "Suporte e treinamento sem custo",
  file_attachment: "Anexar Arquivo",
  feature: "Recurso | Recursos",
  fixed_cost: "Custo Fixo | Custos Fixos",
  first_name: "Primeiro Nome | Primeiros Nomes",
  flow: "Fluxo | Fluxos",
  flow_process: "Fluxo de Processo | Fluxos de Processos",
  file: "Arquivo | Arquivos",
  field: "Campo | Campos",
  filter: "Filtro | Filtros",
  filter_by_user: "Filtrar por usuário | Filtrar por usuários",
  financial: {
    balance: "Saldo | Saldos",
    paid: "Pago | Pago",
    opened: "Em Aberto | Em Aberto",
    received: "Recebido | Recebidos",
    financial_process: "Processo Financeiro | Processos Financeiros",
    income_registration: "Registro de Receita | Registros de Receitas",
    income: "Receita | Receitas",
    expense_registration: "Registro de Despesa| Registro de Despesas",
    expense: "Despesa| Despesas",
    account_receivable: "Account Receivable| Account Receivable",
    financial_recovery: "Cobrança | Cobranças",
    account: "Contas | Contas",
    account_plan: "Plano de Conta | Plano de Contas",
    all_account: "Todas Contas",
    receipt_method: "Método Recebimento | Métodos Recebimentos",
    receipt: "Recebimento | Recebimento",
    payment: "Pagamento | Pagamento",
    cost_center: "Centro de Custo | Centros de Custo",
    default_cost_center: "Centro de Custo Padrão| Centros de Custo Padrão",
    bank_account: "Contas Bancárias | Contas Bancárias",
    financial_account: "Conta Bancária | Contas Bancárias",
    default_account: "Conta Bancária Padrão | Contas Bancárias Padrão",
    label: "Financeiro",
    financial_record: "Registro Financeiro | Registros Financeiros",
    installment: "Parcela | Parcelas",
    payment_method: "Método Pagamento | Métodos Pagamentos",
    price: "Preço | Preços",
    rate: "Taxa | Taxas",
    discount: "Desconto | Descontoss",
    interest: "Juros | Juros",
    additional_fee: "Taxa Adcional | Taxas Adicionais",
    percentage_discount: "Desconto Percentual",
    fixed_discount: "Desconto Fixo",
    allow_installment: "Permitir Parcelamento",
    receive_single_installment: "Receber em parcela única",
    type_interest: "Tipo de Juros",
    compound_interest: "Juros Compostos",
    simple_interest: "Juros Simples",
    add_to_total: "Adicionar ao Total",
    totals_by_cost_center: "Totais por Centro de Custo",
    grouped_by_cost_center: "Agrupado por Centro de Custo",
    incomes_by_cost_center: "Receitas Agrupado por Centro de Custo",
    expenses_by_cost_center: "Despesas Agrupado por Centro de Custo",
    message: {
      cant_edit_paid_records: `Registros de pagamento podem apenas ser excluídos. Ao excluir esses registro, todos os seus registros financeiros serão excluídos também.`,
      cant_edit_received_records: `Registros de recebimento podem apenas ser excluídos. Ao excluir esses registro, todos os seus registros financeiros serão excluídos também. `,
      general_discount_all_payments:
        "Taxas de desconto para todos os pagamentos",
      specific_discount_by_installments:
        "Desconto específico por quantidade de parcelas",
    },
  },
  gender: "Gênero | Gêneros",
  general_registration: "Registro Geral | Registros Gerais",
  home: "Home | Homes",
  height: "Altura | Alturas",
  help_center: "Central de Ajuda | Centrais de Ajuda",
  input: "Campo | Campos",
  in_progress: "Em Andamento",
  id: "Id | Ids",
  import_product: "Importar Produto | Importar Produtos",
  import_selected_profiles:
    "Import Selected Profiles | Import Selected Profile",
  incomplete: "Incompleto | Incompletos",
  institution: "Instituição | Instituições",
  instalment: "Parcela | Parcelas",
  item: "Item | Itens",
  interview: "Intrevista | Intrevistas",
  income: "Receita | Receitas",
  logout: "Log Out",
  logo: "Logo | Logos",
  link: "Link | Links",
  link_to_register_form:
    "Link para o formulário de cadastro | Links para os formulários de cadastro",
  link_to_register: "Link para registrar perfil| Links para registrar perfis",
  linked_user: "Usuário| Usuários",
  linked_user_status:
    "Usuários associados e status | Usuário associado e status",
  last_update: "Última Atualização | Últimas Atualizações",
  linked_process: "Processo Associado | Processos Associados",
  lebel: "Rótulo | Rótulos",
  level: "Nível | Níveis",
  lag_level: {
    ALL: {
      label: "All Níveis",
      desc: "",
    },
    1: {
      label: "Nativo",
      desc: "Língua materna",
    },
    2: {
      label: "Fluente",
      desc: "Alto nível de proficiência",
    },
    3: {
      label: "Independente",
      desc: "Comunicação básica",
    },
    4: {
      label: "Básico",
      desc: "Entende e se comunica com dificuldade",
    },
  },
  education_level: {
    1: {
      label: "Secundário",
    },
    2: {
      label: "Superior",
    },
    3: {
      label: "Mestrado",
    },
    4: {
      label: "Doutorado",
    },
  },
  list: "Lista | Listas",
  login: {
    label: "Login",
    forgot_password: "Esqueceu a senha?",
    change_password: "Alterar senha",
    request_change_password: "Solicite nova senha",
    login_error: "Desculpe, dados de acesso incorretos.",
    change_pw_error: "Erro ao atualizar a senha.",
    request_pw_msn:
      "Requisição recebida com sucesso.<br> Um e-mail foi enviado para {email} com um link para atualizar a senha.",
    password_updated: "Senha atualizada.",
    repeat_password: "Repetir Senha",
  },
  language_set: {
    label: "Linguagem | Linguagens",
    portuguese: "Português",
    portuguese_br: "Português BR",
    english: "Inglês",
    english_us: "Inglês",
    spanish: "Espanhol",
  },
  link_generate: {
    short_explanation: {
      what_is: "O usuário pode criar um usuário e registrar seu perfil.",
      process_bind: "Os processos serão associados com as contas do perfil",
      user_bind:
        "Os usuários serão associados com as contas do perfil. Quando um perfil é atualizado ou um usuário envia um mensagem o dono do perfil receberá mensagens de aviso.",
    },
  },
  language: {
    label: "Idioma | Idiomas",
    portuguese: "Português",
    portuguese_br: "Português BR",
    english: "Inglês",
    english_us: "Inglês",
    spanish: "Espanhol",
  },
  main: "Principal | Principais",
  model: "Modelo | Modelos",
  menu: "Menu | Menus",
  min: "Min | Min",
  max: "Max | Max",
  main_user: "Usuário Principal | Usuários Principais",
  main_process: "Processo Principal | Processos Principais",
  main_profiles: "Perfil Principal | Perfis Principais",
  media: "Mídia | Mídias",
  my_account: "Minha conta | Minhas contas",
  min_stock: "Min Estoque | Min Estoques",
  max_stock: "Max Estoque | Max Estoques",
  my_user: "Meu Usuário | Meus Usuários",
  my_profile: "Meu Perfil | Meus Perfis",
  method: "Metodo | Metodos",
  module: "Módulo | Módulos",
  municipal_code: "Código Municipal | Códigos Municipais",
  message: {
    new_skill_in_select:
      "Para criar uma nova skill, apenas digite e selecione.",
    visible_to_profile_owner:
      "Visível na área do perfil do usuário. Apenas dados básicos do processo.",
    agree_above_terms: "Compreendo e concordo com as orientações acima.",
    agree_update_terms:
      "Compreendo e assumo a responsabilidade sobre os termos de uso e políticas de privaciadade aplicadas ao cadastro de perfil.",
    we_are_preparing_your_account: "Estamos preparando sua conta...",
    account_confirmed: "Obrigado, conta confirmada!",
    compare_ratings_click: "Primeiro, escolha os perfis que deseja comparar.",
    open_windows: "Abrir Janela",
    page_not_found: "Página não encontrada.",
    there_id_no_selected_profile: "Ainda não foram selecionados perfis",
    when_you_receive_payment: "Quando recebe o pagamento",
    when_you_make_payment: "Quando faz o pagamento",
    need_change_plan: "Necessário mudar o plano. <ins>Alterar Plano</ins>",
    confirm_change_account_plan:
      "Quando o plano é alterado, o valor do plano será ajustado e será enviado um e-mail em 48 horas com as informações da alteração da cobrança, se fora do período gratuito.",
    change_account_plan_confirmed: "Mudança de plano CONFIRMADA",
    change_account_plan_canceled: "Mudança de plano CANCELADA",
    choose_process_in_dashboard:
      "Sem dados ou sem tipo de processo selecionado para o Painel de Controle.<br> Escolha os processos que deseja ver aqui.",
    average_from_x_records: "Média de 1 registro | Média de {n} registros",
    total_x_ratings_submitted:
      "1 de avaliação submetida | {n} de avaliações submetidas",
    chart_one_year_by_process_type:
      "Período de 12 meses (considera processos arquivados)",
    started_x_closed_process: "Iniciados X Fechados",
    active_processes_by_status: "Processos ativos por status (não arquivados)",
    actived_processes: "Processo Ativo | Processos Ativos",
    actived: "Ativo | Ativos",
    label: "Mensagem | Mensagens",
    delete_completed: "Exclusão completada",
    remove_completed: "Remoção completada",
    delete_canceled: "Exclusão cancelada",
    remove_canceled: "Remoção cancelada",
    archive_completed: "Aquivamento realizado",
    archive_canceled: "Arquivamento cancelado",
    unarchive_completed: "Arquivamento completado",
    unarchive_canceled: "Arquivamento cancelado",
    equal_or_greater: "Igual ou maior",
    terms_and_policies: "Termos e Políticas",
    privacy_policies: "Políticas de Privacidade",
    terms_of_use: "Termos de Uso",
    account_registered: "Conta registrada",
    confimation_sent: `<p class="h4">
      Uma mensagem com um link de confirmação
      foi enviada para {email}.
      </p>
      <p class="h4">
      Por favor, verifique o e-mail.
      </p>`,
    confimation_sent_simple: `Uma Mensagem com um link de
      confirmação foi enviada para {email}.`,
    mensage_deleted: "Mensage excluída.",
    mensage_sent: "Mensagem enviada.",
    mensage_sent_thanks: "Mensagem enviada. Obrigado!",
    no_rating_registered: "Sem registro de avaliação",
    will_response_soon: `Nós responseremos em breve.`,
    are_you_sure: "Tem certeza?",
    confirm_delete: "Confirmar exclusão?",
    confirm_archive: "Confirmar Arquivamento?",
    confirm_unarchive: "Confirmar Desarquivamento?",
    from_your_selected_skills: "das skills selecionadas",
    filter_by_language: "Filtrar por linguagem | Filtrar por linguagens",
    filter_by_skill: "Filtrar por skills | Filtrar por skills",
    slogan: "Gestão de Processos e Perfis",
    show_edit_mode: "Mostrar Modo de Edição",
    hide_edit_mode: "Esconder Modo de Edição",
    hide_sensitive_data: "Esconder Dados Sensíveis",
    repeat_password: "Repetir senha",
    hello: "Olá!",
    coded_by: "Desenvolvido por",
    updated_by: "Atualizado por",
    updated: "Atualizado | Atualizados",
    created_by: "Criado por",
    month_free: "{n} Dia Grátis | {n}º Dias Grátis",
    no_records: "Sem registros",
    no_profile_added: "Sem prefirs adcionados",
    name_or_code: "Nome ou Código",
    number_job_openings: "Quantidade de vagad abertas",
    number_profile_to_select: "Quantidade {label} para selecionar",
    profile_to_select: "{label} para selecionar",
    data_visible_to_candidate:
      "Informação visível para o usuário do dono do perfil.",
    evaluation_topic_x_weight: "Tópicos de Avaliação X Peso",
    send_owner_link: "Enviar para o dono do perfil",
    send_owner_link_txt: `O dono do perfil poderá atualizar seus dados, acompanhar
    informações básicas dos seus processos, anexar documentos e enviar mensagens.`,
    select_profile_with_ratings: "Selecione um perfil com avaliação.",
    request_owner_update: "Solicite atualização pelo dono do perfil",
    copy_tags: `Copie (Ctrl + C) e cole (Ctrl + V) como uma TAGs no editor
					de texto para exibir o conteúdo correspondente quando
					gerar o documento.`,
    owner_restriction: `Apenas o autor e usuários com o quais houve
							compartilhamento.<br>
							A menos que haja limitação do perfil do usuário:`,
    allow_as_physical_person: "Permitir como uma pessoa física.",
    allow_as_company: "Permitir como empresa.",
    from_selected_skills: "Das skills selecionadas",
    confirm_leave_form:
      "Confirmar deixar esse formulário? Salve antes, para não perder as alterações.",
    confirm_remove_profile_in_process:
      "Confirmar remover perfil desse processo | Confirmar remover perfis dessessss processo",
  },
  name: "Nome | Nomes",
  not_archived: "Não Arquivado | Não Arquivados",
  not_confirmed: "Não Confirmado | Não Confirmado",
  not_rated: "Não Avaliado | Não Avaliados",
  not_selected: "Não Selecionado | Não Selecionados",
  name_singular: "Nome Singular| Nomes Singular",
  name_plural: "Nome Plural| Nomes Plural",
  new_product: "Novo Produto | Novos Produtos",
  new: "Novo | Novos",
  new_type: "Novo Tipo| Novos Tipos",
  number: "Número | Números",
  next: "Próximo | Próximos",
  new_reating: "Nova Avaliação | Novas Avaliações",
  no_status_registered: "Sem Status Registrado | Sem Status Registrados",
  new_account: {
    create_new_account: "Registre nova conta",
    create_your_account: "Registre sua conta",
    profile_management: "Gestão de Perfis",
    process_management: "Gestão de Processos",
    financial_management: "Financial Management",
    text: {
      profile_features: `- Registrar perfis;<br>
              - Link para cadastro de perfils;<br>
								- Área do dono do perfil;<br>
								- Enviar mensagens rápidas para os donos dos perfis;<br>
								`,
      process_features: `- Tarefas; <br> 
								- Processos seletivos;<br>
								- Processo de contratação;<br>
								- Entrevista;<br>
								- Vendas;<br>
								- Cotação;<br>
								- Compra;<br>
								- Processos personalizados;<br>
								- Outros...<br>
								`,
      financial_features: `- Registrar Receitas;<br>
								- Registrar Despesas;<br>
								- Relatórios Financeiros;<br>`,
    },
  },
  only_open_task: "Apenas tarefas em aberto | Apenas tarefas em aberto",
  official_identification: "Identificação Oficial | Identificações Oficiais",
  observation: "Observação | Observações",
  ok: "Ok",
  online_system: "Sistema Online | Sistemas Online",
  operating_area: {
    label: "Área de Atuação",
    culture: "Cultura",
    human_resources: "Recursos Humanos",
    provide_services: "Provedor de Serviços",
    product_sales: "Venda de Produtos",
    products_and_services: "Produtos e Serviços",
    financial: "Financeiro",
    education: "Educação",
    ti: "TI",
    marketing: "Marketing",
    health: "Saúde",
    others: "Outros",
  },
  opened: "Em Aberto | Em Aberto",
  open_task: "Tarefa em Aberto | Tarefas em Aberto",
  overview: "Visão Geral | Visões Gerais",
  origin_process: "Processo de Origem | Processos de Origem",
  per_user_per_month: "por usuário por mês",
  pending: "Pendente",
  process: "Processo | Processos",
  process_and_profile_configurator: "Configurador de processos e perfis",
  process_settings: "Configuração do Processo | Configurações dos Processos",
  process_permissions: "Permissição do Processo | Permissições do Processo",
  process_management: "Gestão de Processos",
  perishable: "Perecível | Perecíveis",
  process_module: {
    label: "Módulo do Processo| Módulos do Processo",
    process: "Processo | Processos",
    message: {},
  },
  process_id: "ID Processo | IDs Processos",
  process_type: "Tipo de Processo | Tipos de Processos",
  process_resume: "Resumo do Processo | Resumo dos Processos",
  profile: "Perfil | Perfis",
  profile_status: {
    label: "Status do Perfil | Status dos Perfis",
    desc:
      "Acompanhe e atualize facilmente o status de todos os perfis que participam de um processo.",
  },
  profile_and_curriculum: "Perfil & Currículo| Perfis & Currículos",
  profile_group: "Grupo de Perfil | Groups de Perfil",
  profile_removed: "Perfil Removido | Perfis Removidos",
  profile_settings: "Configuração do Perfil | Configurações dos Perfis",
  profile_permissions: "Permissão do Perfil | Permissões do Perfil",
  profile_n: "{n} Perfil | {n} Perfis",
  profile_type: "Tipo de Perfil | Tipos de Perfis",
  profile_user: "Usuários do Perfil | Usuários dos Perfis",
  permissions: {
    label: "Permissão | Permissões",
    allow_rating_profile: "Permitir avaliar perfil | Permitir avaliar perfis",
    profile_user_permission:
      "Permissão de usuário de perfil | Permissões de usuários de perfil",
    show_in_his_process_list:
      "Exibir em sua listagem de processo | Exibir em sua listagens de processos",
    show_basic_data: "Exibir dado básico | Exibir dados básicos",
    show_product: "Exibir Produto | Exibir Produtos",
    show_product_value: "Exibir valor do produto | Exibir valor dos produtos",
    show_income: "Exibir Conta a Receber | Exibir Contas a Receber",
    show_expense: "Exibir Conta a Pagar | Exibir Contas a Pagar",
    show_file: "Exibir Arquivo | Exibir Arquivos",
    show_process_flow: "Exibir flúxo do processo | Exibir flúxo dos processos",
    show_profile_list: "Exibir Lista de Perfis | Exibir Listas de Perfis",
    show_profile_cv: "Exibir CV | Exibir CVs",
    show_comment: "Exibir Comentário | Exibir Comentários",
    add_file: "Adicionar Arquivo | Adicionar Arquivos",
    in_selective_process: "No processo seletivo | Nos processos seleticos",
  },
  product: "Produto | Produtos",
  product_destination: "Destinatário do Produto | Destinatários do Produtos",
  product_origin: "Origem do Produto | Origens dos Produto",
  product_updated: "Produto Atualizado | Produtos Atualizados",
  product_registered: "Produto Registrado| Produtos Produtos",
  project: "Projeto | Projetos",
  position: "Posição | Posições",
  previous: "Anterior | Anteriores",
  password: "Senha | Senhas",
  password_repeat: "Repetir Senha | Repetir Senhas",
  payment: "Pagamento | Pagamentos",
  point: "Ponto | Pontos",
  profile_id: "ID do Perfil | IDs dos Perfis",
  professional_identification:
    "Identificação Profissional | Identificações Profissionais",
  plan: {
    label: "Plano | Planos",
    for_custom: "Para planos personalizados, contactar {email}",
    use_your_domain: {
      label: "Seu Domínio",
      text: "Será usado o seu domínio para acessar a sua conta.",
    },
    use_your_email: {
      label: "Seu e-mail",
      text:
        "Poderá usar o e-mail corporativo quando o sistema enviar mensagens da sua conta.",
    },
    your_logo: {
      label: "Sua Logo",
      text:
        "Use your corporate email address when the system sends messages from your account.",
    },
    custom_theme: {
      label: "Suas cores e temas",
      text:
        "Use your corporate email address when the system sends messages from your account.",
    },
    custom_features: {
      label: "Recursos Personalizados",
      text:
        "Use your corporate email address when the system sends messages from your account.",
    },
  },
  quotation: "Cotação | Cotação",
  quotation_and_purchase: "Cotação/Compras",
  ranking: "Ranking | Rankings",
  resend_confimation_email: "Reenviar email de confirmação.",
  result: "Resultado | Resultados",
  registered_reating: "Avaliação Registrada | Avaliações Registradas",
  ratings: "Avaliação | Avaliações",
  registered_date: "Data de Registro | Datas de Registro",
  rating_submitted: "Avaliação Submetida | Avaliações Submetidas",
  rating_deleted: "Avaliação Deletada | Avaliações Deletadas",
  required: "Obrigatório | Obrigatórios",
  recent_activity: "Atividade Recente | Atividades Recentes",
  responsible: "Responsável | Responsáveis",
  responsible_user: "Usário responsável | Usários responsáveis",
  raking_position: "Posição no Raking | Posições no Raking",
  raking: "Raking | Rakings",
  rating_record: "Registro de Avaliação | Registros de Avaliações",
  requirement: "Requisito | Requisitos",
  role: "Papel | Papeis",
  saved: "Salvo | Salvo",
  recruitment: "Recrutamento | Recrutamento",
  referral: {
    label: "Referência | Referências",
    have: "Possui referência | Possui referências",
    label_email: "E-mail de Referência | E-mail de Referências",
    text_register: "E-mail da pessoa que lhe apresentou o sistema",
  },
  resume: "Resumo | Resumos",
  record: "Registro | Registros",
  rating: "Avaliação | Avaliações",
  subject: "Assunto | Assunto",
  setting: "Configuração | Configurações",
  stock_control: "Controle de Estoque | Contole de Estoques",
  state_code: "Código do Estado | Códigos do Estado",
  selected: "Selecionado | Selecionados",
  start: "Começo | Começos",
  started: "Iniciado | Iniciados",
  start_date: "Data Início | Datas Início",
  storage: "Armazenamento | Armazenamentos",
  shipping: "Entrega | Entregas",
  specialization: "Especialização | Especializações",
  summary: "Apresentação | Apresentações",
  start_page: "Página Inicial",
  serial_number: "Serial Number | Serial Numbers",
  selective_process: "Processo Seletivo | Processo Seletivo",
  skill: "Skill | Skills",
  skill_levels: {
    ALL: "Todas | Todas",
    1: "Iniciante | Iniciantes",
    2: "Intermediário | Intermediários",
    3: "Profissional | Profissionals",
    4: "Senior | Seniors",
    5: "Expert | Experts",
  },
  stock: "Estoque | Estoques",
  service: "Serviço | Serviços",
  selection_data: "Dado Selecionado | Dados Selecionados",
  status: "Status | Status",
  status_detail: "Detalhe do Status| Detalhe do Status",
  supplier: {
    label: "Fornecedor | Fornecedores",
    name: "Nome Fornecedor | Nomes Fornecedores",
    code: "Código Fornecedor | Códigos Fornecedores",
    contact: "Contato Fornecedor | Contatos Fornecedores",
  },
  to: "Para",
  to_sale: "Para Venda | Para Vendas",
  tag: "Tag | Tag",
  title: "Título | Títulos",
  street: "Rua | Ruas",
  weight: "Peso | Pesos",
  task: "Tarefa | Tarefas",
  team_management: "Gestão de Equipes",
  term: "Termo | Termos",
  type: "Tipo | Tipos",
  time: "Hora | Horas",
  technology: "Tecnologia | Tecnologias",
  total: "Total | Totais",
  total_by_status: "Total por Status | Totais por Status",
  topic_point: "Pontuação no Tópico | Pontuações nos Tópicos",
  topic: "Tópico| Tópicos",
  topic_type: {
    integer: "Número",
    value: "Monetário",
    decimal: "Número Decimal",
    stars: "Estrelas",
    boolean: "Sim/Não",
  },
  undone: "Não Finalizado | Não Finalizados",
  url: "Url | Urls",
  unlimited: "Ilimitado | Ilimitados",
  updated: "Atualizado | Atualizados",
  user: {
    label: "Usuário | Usuários",
    select: "Selcione usuário | Selcione usuários",
  },
  n_user: {
    label: "{n} Usuário | {n} Usuários",
  },
  value: "Valor | Valores",
  your_profile: "Seu Perfil | Seu Perfil",
  your_comment: "Seu Comentário | Seu Comentários",
  your_message: "Sua Mensagem | Suas Mensagens",
  warning: "Aviso | Avisos",
  kanban: "Card | Cards",
  site: {
    register: {
      title: "Criar Conta FREE",
      subtitle:
        "Crie sua conta gratuita agora e comece a utilizar o ProcessFlex.",
      btn_create_your_account: "Criar Conta FREE",
      registered: {
        title: "Conta Registrada",
        msn:
          "Uma mensagem de confirmação foi enviada para {email} de app@processflex.com. <br> Se não encontrar a mensagem, verifique a caixa de spam.",
        check_email: "Por favor, verifique seu e-mail.",
        accept_terms: "Aceito os termos de uso.",
        accept_privacy_policy: "Aceito as políticas de privacidade.",
      },
    },
    home: {
      title: "Gestão de Processos e Perfis",
      subtitle: `
					Defina status, responsáveis, checklist, prazos e muito mais, tudo em um único sistema, fácil e flexível.
			`,
      features: {
        title: "Recursos",
        subtitle: "Conheça alguns dos recursos que o ProcessFlex oferece:",
        process: {
          desc: `
						<p class="text-justify">
							Use os processos pré-existentes ou crie novos tipos livremente. 
							Tenhas o controle dos teus processos com um configurador e 
							faça os ajustes para adequar cada tipo de processo à sua realidade.
						</p>
						<p class="text-justify"> 
							Defina status, quem participa deles, receba arquivos,
							envie mensagens, monte sua equipe e mais.
						</p>					
					`,
        },
        profile_and_cv: {
          desc: `
					<p class="text-justify">
						Canditatos, clientes, fornecedores, funcionários ou o que mais precisar,
						crie tipos de perfis novos e ajuste suas configurações livremente.
					</p>
					<p class="text-justify">
						Tenha links específicos para o registro diretamente pelo dono do perfil, seja 
						um candidato, cliente, fornecedor ou qualquer outro tipo de perfil.
					</p>					
					`,
        },
        custom_features: {
          desc: `
					<p class="text-justify">
						Possui necessidades únicas e não encontra soluções adequadas?
						Apenas você sabe o que a sua empresa realmente precisa.
					</p>
					<p class="text-justify">
						Entre em contato e vamos conversar para encontrarmos as melhores
						soluções para o seu caso.
					</p>
					`,
        },
      },
    },
    tasks: {
      desc: `
			<p>
			Facilite a gestão de suas tarefas e de sua equipe. Registre as tarefas e as gerencie de forma fácil e simples.
			</p>
			<p>
					Mantenha todas as tarefas em ordem. Controle seus status, defina responsabilidades, descreva atividades que devem ser concluídas, anexe arquivos e muito mais.
			</p>
			<p>
					Faça buscas de tarefas de maneira simples e inteligente para mantê-las organizadas e atualizadas. Quando concluídas, simplesmente "arquive-as" para referência futura ou para gerar relatórios sobre atividades passadas.
			</p>
				`,
      list: `
			<p><strong>Criação de Novas Tarefas:</strong> Registre novas tarefas de forma fácil e rápida;</p>
			<p><strong>Filtragem Inteligente:</strong> Busque suas tarefas por título, período, status, etc;</p>
			<p><strong>Criação Personalizada de Status:</strong> Crie os status que quiser, na ordem que desejar;</p>
			<p><strong>Visualização em Modo Kanban Board:</strong> 
					Tenha colunas com os status que você definiu e cartões com cada tarefa. Arraste para atualizar status, edite as tarefas como desejar;</p>
			<p><strong>Todo-list:</strong> Relacione tudo o que precisa ser feito para cada tarefa em uma lista e controle o que já foi feito;</p>
			<p><strong>Atribuição de Responsável pelas Tarefas:</strong> Defina quem é responsável pela tarefa;</p>
			<p><strong>Anexar Arquivos e Imagens:</strong> Anexe documentos e imagens para ter tudo o que está relacionado à tarefa em um só lugar;</p>
			<p><strong>Tarefas Derivadas:</strong> De uma tarefa principal, crie outras tarefas derivadas;</p>			
			`,
    },
    quotation_and_purchase: {
      desc: `
			<p>
				Transforme a gestão de compras da sua empresa com o nosso sistema de Cotação e Compras. 
				Simplifique o processo de solicitar cotações, analisar propostas e fechar negócios de maneira eficiente.
			</p>
			<p>
				Avalie e compare os melhores fornecedores, garantindo a escolha ideal para a sua empresa. 
				Além disso, mantenha controle total sobre as decisões, bloqueando as aprovações de compras até 
				serem autorizadas por um usuário designado. Aumente a eficiência operacional e tome decisões estratégicas
				para o crescimento do seu negócio.
			</p>
			`,
      list: `
			<p><strong>Registro de cotações e compras:</strong> Registre de forma fácil e rápida;</p>
			<p><strong>Filtragem Inteligente:</strong> Encontre os seus processos de forma simples;</p>
			<p><strong>Compare fornecedores:</strong> Defina os critérios de avaliação e escolha sempre a melhor opção conforme as avaliações feitas;</p>
			<p><strong>Cadastro de fornecedores:</strong> Mantenha o seu banco de dados de fornecedores sempre atualizado e disponível;</p>
			<p><strong>Anexe documentos:</strong> Anexe documentos digitalizados;</p>
			<p><strong>Atribuição de Responsável:</strong> Defina quem é responsável pelos processos;</p>		
			`,
      ai: {
        title: "IA",
        desc:
          "Use o poder da <strong>inteligência artificial</strong> para comparar fornecedores e fazer a melhor escolha.",
      },
    },

    resumes: {
      company: {
        desc: `
			<p>
				Crie e gerencie seu banco de currículos.
				Currículos adicionados por sua conta serão exclusivos aos seus usuários
				e compartilhável com links protegidos.
			</p>
			<p>
				<i class="icon-magic-wand"></i> Use a <strong>inteligência artificial</strong> para gerar os textos de apresentação dos CVs.
			</p>`,
      },
      candidate: {
        desc: `
			<p>
				Tenha agora mesmo seu currículo de
				forma fácil, rápida e sem custo.
				Compartilhes através de links,
				PDF ou por impressão.
			</p>
			<p>
				<i class="icon-magic-wand"></i> Use a <strong>inteligência artificial</strong> para gerar o texto de apresentação do seu CV.
			</p>`,
      },
    },
    recruitment: {
      title: "Recrutamento e Currículos ",
      subtitle: `
			<p>
			Tenha total controle dos processos de recrutamento e gestão
				da base de currículos da sua empresa.
			</p>
			<p>
				<ul class="text-left">
					<li>
						Gestão do recrutamento;
					</li>
					<li>
						Banco de Currículos;
					</li>
					<li>
						Área "Trabalhe Conosco";
					</li>
					<li>
						Outros processos e perfis configuráveis;
					</li>
					<li>
						Controle Financeiro;
					</li>
				</ul>
			</p>
			`,
      features: {
        title: "Recursos",
        subtitle: "Conheça alguns dos recursos que o ProcessFlex oferece:",
        process: {
          desc: `
						<p class="text-justify">
							Use os processos pré-existentes ou crie novos tipos livremente. 
							Tenhas o controle dos teus processos com um configurador e 
							faças os ajustes para adequar cada tipo de processo à sua realidade.
						</p>
						<p class="text-justify"> 
							Defina status, quem participa deles, receba arquivos,
							envie mensagens, monte sua equipa e mais.
						</p>					
					`,
        },
        profile_and_cv: {
          desc: `
					<p class="text-justify">
						Canditatos, clientes, fornecedores, funcionários ou quem mais precisas,
						crie tipos de perfis novos e ajuste suas configurações como precisas.
					</p>
					<p class="text-justify">
						Tenha links específicos para o registo diretamente pelo dono do perfil, seja 
						um candidato, cliente, fornecedor ou qualquer outro tipo de perfil.
					</p>					
					`,
        },
        custom_features: {
          desc: `
					<p class="text-justify">
						Possui necessidades únicas e não encontras soluções adequadas?
						Apenas tu sabes o que a sua empresa realmente precisa.
					</p>
					<p class="text-justify">
						Entre em contato e vamos conversar para encontrarmos as melhores
						soluções para o seu caso.
					</p>
					`,
        },
      },
    },
    plans: {
      subtitle: "Escolha um dos planos ou solicite uma solução sob medida.",
    },
    features: {
      title: "Recursos",
      subtitle: `
			<p>Recursos flexíveis e personalizáveis, como realmente precisa.</p>
			<p>
			ProcessesFlex é um sistema de gestão de processos e perfis. 
			Pode ser uma compra, um projeto, um processo seletivo, desenvolvimento de um produto
			ou qualquer outro processo que você precisa ter controle.<br>
			</p>
			<p>
			Defina quais os tipos de perfis que fazem parte do processo, os status, se há movimentação financeira, produtos, 
			comparação de perfis (para processos selectivos ou de cotação, por exemplo) e mais. <br>
			</p>
			<p>
			Tenha processos pré-configurados e personalize tudo a sua maneira.<br> 
			</p>
			<p>
			Se tiver alguma dúvida, entre em contato e tenha todo o suporte necessário.
			</p>
			`,
      processes: {
        title: "Processos",
        subtitle: "Crie e personalize processos",
        pre_registered: {
          title: "Pré-registrados:",
          list: `
					<ul class="col-md-5">
						<li>Tarefas;</li>
						<li>Recrutamento;</li>
						<li>Compras;</li>
						<li>Vendas;</li>
						<li>Projetos;</li>
					</ul>
					<ul class="col-md-5">
						<li>Cotação;</li>
						<li>Meeting;</li>
						<li>Contratação;</li>
						<li> E muito mais... </li>
					</ul>
				`,
        },
        features: {
          title: "Recursos",
          list: `
					<ul class="col-md-5">
						<li>Status personalizados;</li>
						<li>Tarefas vinculadas;</li>
						<li>Seleção de perfis;</li>
						<li>Avaliação de perfis;</li>
						<li>Comparação de perfis;</li>
						<li>Anexar aquivos;</li>
						<li>Enviar mensagem;</li>
					</ul>
					<ul class="col-md-5">
						<li>Productos e serviços;</li>
						<li>Controle de custos e receitas;</li>
						<li>Anexar arquivos;</li>
						<li>Prazos;</li>
						<li>Time line;</li>
						<li>Canban board;</li>
						<li>Atribua membros da equipe;</li>
					</ul>
					`,
        },
        new_types: {
          title: "Novos tipos de processos:",
          content:
            "Criação ilimitada de novos tipos de processos personalizados.",
        },
      },
      profiles: {
        title: "Base de Perfis",
        subtitle: "Base de perfis personalizável.",
        pre_registered: {
          title: "Pré-registrados:",
          list: `
					<ul>
						<li>Clientes</li>
						<li>Fornecedores</li>
						<li>Candidatos</li>
						<li>Consultores</li>
						<li>Funcionários</li>
					</ul>
					<ul>
						<li>Empregados</li>
						<li>Vendedores</li>
						<li>Transportadores</li>
						<li> E muito mais... </li>
					</ul>`,
        },
        features: {
          title: "Recursos",
          list: `
					<ul class="col-md-6">
						<li>Criação de CV;</li>
						<li>Buscas por skills, línguas, etc;</li>
						<li>Link exclusivo para registro;</li>
						<li>Processos vinculados;</li>
						<li>Avaliação de perfis;</li>
						<li>Comparação de perfis;</li>
						<li>Enviar mensagem;</li>
					</ul>
					<ul>
						<li>Anexar aquivos;</li>
						<li>Skills;</li>
						<li>Projetos;</li>
						<li>Línguas;</li>
						<li>Atividades;</li>
						<li>Educação;</li>
					</ul>
				`,
        },
        new_types: {
          title: "Novos tipos de perfis:",
          content: "Criação ilimitada de novos tipos de perfis personalizados.",
        },
      },
      tasks: {
        title: "ToDo",
        create_and_assing: {
          title: "ToDo list",
          description:
            "Crie e atribua atividades para serem realizadas pelos membros da equipe.",
        },
        all_your_tasks: {
          title: "Sua ToDo list",
          description:
            "Tenha uma lista com todas as suas atividades que precisam ser realizadas. Nunca se esqueça do que precisa ser feito.",
        },
        process_tasks_status: {
          title: "Filtrar ToDo list",
          description: "Em cada processo, filtre a ToDo list por status.",
        },
      },
      financial: {
        title: "Financeiro",
        subtitle: "Controle financeiro dos processos",
        features: {
          title: "Recursos",
          list: `
					<ul class="col-md-5">
						<li>Contas a pagar;</li>
						<li>Contas a receber;</li>
						<li>Centros de Custo;</li>
						<li>Receitas de processos;</li>
					</ul>
					<ul class="col-md-5">
						<li>Despesas de processos;</li>
						<li>Filtros de movimentações;</li>
						<li>Gráficos financeiros;</li>
						<li>Extrato de movimentações;</li>
					</ul>
				`,
        },
      },
    },
  },
  terms: `
		O uso do Sistema CllFlex implica a aceitação destes Termos e Condições Legais pelo usuário (a partir deste ponto, referido sempre como o ‘Usuário’). Da mesma forma, o uso da Web, destinado para pessoas da idade legal necessária, implica que o Usuário está completamente capacitado para agir em seu próprio nome. É necessário que o Usuário leia cuidadosamente este documento e esteja ciente de que a CllFlex e os Termos e Condições Legais descritos aqui podem estar sujeitos a mudanças.
		<br><br>
		Definições
		<br><br>
		Termos e Condições Legais: Este documento, assim como qualquer adendo, anexo, notas, ou alterações que podem ser incluídas, a qualquer instante enquanto a Web permanece válida e atuando, constitui os termos e condições legais a respeito da relação entre o Usuário e a Web.
		<br><br>
		Documentos: Documentação profissional tais como Históricos Curriculares (currículos), perfis eletrônicos, cartas de apresentação, fotografias, vídeos, gráficos, imagens, tabelas de conteúdo, textos, dados, comentários de Usuários, comunicações, publicações, mensagens, artigos e qualquer outro tipo semelhante de conteúdo que pode ser incorporado na Web e editado, criado, alterado, etc.
		<br><br>
		Serviços: Conteúdos especializados e serviços relacionados à documentação profissional, incluindo aqueles que permitem a criação de currículos, perfis eletrônicos, cartas de apresentação, fotografias, vídeos, gráficos, imagens, tabelas de conteúdo, textos, dados, comentários de Usuários, comunicações, publicações, mensagens, artigos e qualquer outro tipo semelhante de conteúdo que pode ser incorporado na Web.
		<br><br>
		Usuários: A pessoa que está autorizada a acessar o Site de acordo com os modos disponíveis, tanto um visitante quanto um Usuário em potencial da Web ou com cadastro prévio na Web e assim sendo a pessoa que aceita a estes Termos e Condições Legais para o uso dos serviços oferecidos por www.processflex.com.
		<br><br>
		Web/Site: O local na internet onde www.processflex.com oferece os seus serviços, gerenciado e comercializado pela Web e / ou os seus parceiros e associados de negócios.
		<br><br>
		Marca Registrada
		<br><br>
		Os serviços disponíveis no site da web www.processflex.com são oferecidos pela Web, uma marca registrada e gerenciada inteiramente por  (a partir deste ponto, referida como a ‘Empresa’) atuando na Espanha em sua sede localizada em e registrada no Registro Comercial de Barcelona (Registro Mercantil de Barcelona: T 45832, F 48, S 8, H B500429, I/A 1) com o número B66969718.
		Através de seu site na web www.processflex.com, a Empresa oferece aos seus Usuários informações claras e precisas sobre as características dos produtos e serviços comercializados, assim como os detalhes necessários para o contato com a sua sede na Espanha.
		<br><br>
		Descrição dos Serviços
		<br><br>
		O www.processflex.com é uma plataforma de serviços que permite aos seus Usuários acessar conteúdos e serviços especializados (a partir deste ponto, referidos como ‘os Serviços’) relativos à documentação profissional tais como os que permitem a criação de currículos, perfis eletrônicos, cartas de apresentação, fotografias, vídeos, gráficos, imagens, tabelas de conteúdo, textos, dados, comentários de Usuários, comunicações, publicações, mensagens, artigos e outros tipos semelhantes de conteúdo. Todo o conteúdo e todos os serviços disponíveis na Web que não foram incorporados até a data de ‘Última Atualização’ no início destes Termos e Condições Legais serão considerados automaticamente como inclusos nos Serviços já que eles formam parte da Web.
		O propósito da Web é servir como um portal na Internet no qual os Usuários podem criar os seus Documentos, e para que certas empresas tenham acesso ao fim de recrutamento, seleção, entrevista profissional, oferecimento de serviços, etc. O www.processflex.com não avalia, controla, edita ou monitora os Documentos, e não faz avaliação dos mesmos ou faz seleções de Documentos ou de indivíduos. O Site não está envolvido em quaisquer transações ou trocas de informação entre os contratantes e os Usuários, por isso o Site não possui controle sobre a qualidade, vericidade, confiabilidade, sinceridade, integridade ou disponibilidade dos Documentos, nem a habilidade de que contratantes em potencial ofereçam oportunidades de carreira, nem que indivíduos completem as candidaturas de empregos. O www.processflex.com não fará declarações ou garantias de nenhum tipo sobre contratantes ou indivíduos em potencial.
		A informação que se torna disponível através da Web, incluindo qualquer informação relativa à criação, alteração e / ou revisão de Documentos no Site, será governada pela Política de Privacidade do www.processflex.com, que está disponível na página www.processflex.com/politica-de-privacidade (a ‘Política de Privacidade’). Estes Termos e Condições Legais incorporam os termos estabelecidos na Política de Privacidade como necessário.
		<br><br>
		Ao se criar Documentos usando os Serviços da Web, os Usuários concedem o consentimento de armazenamento oferecido pela Web, assim como a possibilidade de compartilhá-los com contratantes ou partes terceiras que possuam acesso aos perfis eletrônicos dos Usuários de acordo com os regulamentos aplicáveis e com a Política de Privacidade. No evento em que a conexão ao Site seja produzida através dos serviços de uma parte terceira, os Usuários concordam que o www.processflex.com pode acessar e usar a informação destes serviços da maneira permitida, e armazenar estes credenciais para o seu uso.
		Para acessar a Web, os Usuários devem possuir o equipamento necessário, o que inclui todas as ferramentas necessárias para se estabelecer uma conexão à Internet (incluindo computadores ou laptops, modems, tablets, outros dispositivos, etc.) em que o Site não pode ser mantido de nenhuma forma como responsável.
		Cadastro, nomes de usuário e senhas<br><br>
		<br><br>
		Os Usuários necessitarão se cadastrar no www.processflex.com para acessar certos Serviços ou locais da Web. Com respeito ao cadastro, o Site pode se recusar a atribuir um nome de usuário (ou endereço de e-mail) que já está em uso por outra pessoa, o que pode resultar no uso ilegal da conta de outra pessoa; que viola ou pode violar uma quantidade de propriedade intelectual ou outros tipos de direitos; que é ofensivo ou que o Site determina ser inaceitável por qualquer motivo ao exercer a sua total discrição.
		<br><br>
		O nome de usuário e senha atribuídos são para uso pessoal apenas e estão proibidos de serem usados por outras pessoas, incluindo colegas das mesmas organizações que o Usuário, aqueles que oferecem ou recebem serviços para ou do Usuário, ou afiliados. Os Usuários se responsabilizam por manter a confidencialidade de quaisquer senhas que eles possam usar para acessar a Web, e se comprometer a não transferir, comunicar ou entregar os seus nomes de usuário ou senhas, ou emprestar ou transferir de qualquer outra forma os seus direitos de uso ou acesso à Web a quaisquer partes terceiras.
		<br><br>
		O Site pode monitorar o uso de nomes de usuário ou senhas e pode solicitar que o Usuário os altere sob à sua própria discrição. No evento em que um nome de usuário ou senha não alcance as condições de segurança necessárias, o www.processflex.com pode solicitar imediatamente a sua alteração, ou efetuar o encerramento da conta do Usuário.
		Os Usuários são inteiramente responsáveis por qualquer interação na Web que ocorra com respeito aos seus próprios nomes de usuário ou senhas, incluindo mas não limitado a quaisquer possíveis transações, e especificamente quaisquer custos sujeitos. Os Usuários concordam em comunicar imediatamente à Web sobre qualquer uso não autorizado de seus nomes de usuário ou senhas, ou qualquer outro incidente de segurança com relação às suas contas, ou à própria Web, e também se certificar de que encerrem as suas sessões de uso na Web (se necessário) ao fim de cada sessão. O Site não deve ser responsável por qualquer perda ou dano que possa ocorrer na falha destas responsabilidades.
		<br><br>
		O Site reserva o direito de avaliar cada pedido de Usuário antes de permitir o uso dos Serviços oferecidos e os Usuários ao entrar em um contrato com o Site aceitam isto. O Site pode, à sua total discrição:
		Monitorar solicitações para o uso dos Serviços.<br><br>
		Alterar, excluir ou rejeitar qualquer solicitação,
		Comunicar solicitações e quaisquer circunstâncias relevantes a partes terceiras quando necessário para o uso dos Serviços, de acordo com os regulamentos aplicáveis.
		<br><br>
		Pagamento pelos Serviços<br><br>
		No evento em que os Usuários contratem os Serviços de www.processflex.com, seja para uso único ou através de uma inscrição, os Usuários concedem o seu consentimento de que partes terceiras podem processar e armazenar os seus dados de pagamento para o fim de receber pagamento dos Serviços contratados com o Site, de acordo com as regras de aplicação e com a Política de Privacidade.
		A contratação dos Serviços do Site será feita através do pagamento da quantia correspondente junto de quaisquer taxas ou impostos resultantes da aplicação. No evento em que a coleta de renda seja efetuada por Autoridades Públicas através do www.processflex.com, os Usuários concedem o seu consentimento e concordam em reembolsar tais valores, se necessário o pagamento.
		Os Usuários podem efetuar o pagamento dos Serviços da Web através de pagamentos frequentes ou recorrentes do valor correspondente, que será estabelecido no momento da finalização do contrato com o Usuário. Os Usuários receberão a informação correspondente aos termos do pagamento de maneira entrada em acordo com a Web e de acordo com quaisquer regulamentos aplicáveis, incluindo o procedimento da finalização do pagamento dos Serviços.
		<br><br>
		Pagamentos Ocasionais
		<br><br>
		O www.processflex.com oferece a possibilidade de contratar os Serviços por um período definitivo, ou através dos planos Básico e Premium. Ao contratar um plano Premium, os Usuários concordam em pagar a quantia aplicável, que será processada no momento do cadastro e incluirá o uso do plano Premium durante o período de inscrição em acordo (30 dias / um ano). Os Usuários pagarão pelos Serviços contratados durante o período de inscrição e até o cancelamento.
		Os períodos de inscrição serão renovados automaticamente em períodos de tempo idênticos aos inicialmente contratados, a não ser que o Usuário ou o Site efetuem o cancelamento da inscrição antes do fim do período de inscrição atual. Para o cancelamento da inscrição, os Usuários podem realizá-lo através de suas páginas de perfil pessoais https://app.onlinecurriculo.com/editor/profile/ ao seguir estes simples passos https://www.processflex.com/cancelar-a-inscriaco ou ao enviar um e-mail para info@onlinecurriulo.com.
		Os Usuários devem fornecer dados para o pagamento dos Serviços que sejam verídicos, precisos e atualizados. No evento em que as informações de pagamento não sejam atualizadas e o Usuário não tenha comunicado as novas informações de pagamento, o Site coletará qualquer quantia devida aos Serviços contratados usando o método de pagamento inicialmente designado. Os Usuários serão responsáveis pelo pagamento de quaisquer quantias devidas ao Site.
		Possíveis imagens, descrições, ou referências a produtos ou serviços na Web não implicam automaticamente a garantia, fidelidade ou obrigação de venda ou comercialização destes itens pelo Site. O www.processflex.com reserva o direito, com ou sem aviso prévio, de fazer alterações em tais imagens, descrições ou referências, de limitar a quantidade disponível de qualquer produto ou serviço, de esclarecer ou introduzir limites ou condições para servir algum cupom de desconto, código promocional tanto em cupons quanto em outros elementos, ou outras promoções, de proibir os Usuários de efetuarem certas transações de acordo com estes termos, e de rejeitar a oferta de produtos ou Serviços a qualquer usuário.
		O preço e a disponibilidade de qualquer produto ou serviço na Web são sujeitos a variações e alterações de vez em quando sem aviso prévio e de acordo com as especificações da Web. Quaisquer reembolsos ou alterações aos Serviços do Usuário serão efetuados de acordo com as políticas de reembolso e transferências da Web. Os Usuários devem pagar quaisquer quantias que podem ter se tornados sujeitos com os Serviços da Web, nos termos concordados ao contratar os Serviços, incluindo, se aplicável, quaisquer custos associados (tais como o frete e os custos de armazenamento), e as taxas e os impostos aplicáveis.
		<br><br>
		Pagamentos e Inscrições
		<br><br>
		Se você efetuar a compra de qualquer um dos serviços que oferecemos por uma quantia, inscrição única ou completa, você concorda que os fornecedores da Empresa podem armazenar as suas informações de pagamento. Você também concorda em pagar as taxas aplicáveis pelos produtos ou serviços que você solicitou (incluindo inscrições em períodos mensais ou anuais) em suas datas de expiração, além de todas as taxas relacionadas, e nos reembolsar por quaisquer cobranças e juros sobre as quantias em atraso.
		O não-pagamento pode fazer com que a sua inscrição seja encerrada. Dependendo da origem de suas transações, do método de pagamento usado e da origem do método de pagamento, a sua transação pode estar sujeita a taxas aplicáveis pela conversão de moeda ou pelas diferenças de preço devido à troca. A sua transação pode estar sujeita a uma conversão de moeda efetuada pelo seu banco ou pelo emissor do seu cartão. A Empresa não é responsável por quaisquer custos de conversão ou sobretaxas impostas pelo seu banco ou pelo emissor do seu cartão. A Empresa não aceita todos os métodos, moedas ou locais de pagamento. Se o método de pagamento que você usa conosco expirar, tal como um cartão de crédito ou de débito, e você não editar as suas informações de pagamento ou cancelar a sua conta ou o serviço, você nos autoriza a continuar a cobrar através daquele mesmo método de pagamento, e você se tornará responsável pelas quantias não pagas.
		Todas as taxas aplicáveis são calculadas levando em consideração as informações de pagamento que você oferece no momento da compra. Você concorda que qualquer produto ou serviço comprado por você está sujeito a estas condições e todas as condições adicionais relacionadas ao produto ou ao serviço por nós oferecido.
		Períodos Mínimos de Contrato e Direitos de Cancelamento
		O usuário possuirá o direito de reversão por um meio em que ele/ela pode solicitar o cancelamento dos Serviços e o período de 14 dias para baixar todos os Documentos armazenados até a data na Web, garantindo o retorno da quantia paga durante esse período. Além disso, o usuário pode cancelar o serviço a qualquer momento durante o período de inscrição atual para evitar a cobrança de quantias subsequentes. Para fazer isso, é necessário entrar em contato com o serviço ao cliente no endereço de e-mail info@onlinecurriulo.com ou também fazê-lo diretamente através da página de perfil https://app.onlinecurriculo.com/editor/profile/ ao seguir estes simples passoshttps://www.processflex.com/cancelar-a-inscricao. Se você cancelar um período de inscrição de mais de um mês, você receberá um reembolso dos meses restantes em seu período de inscrição por inteiro. O mês atual será cobrado e o Usuário terá acesso à inscrição pelo resto desse mês. Os meses parciais não serão reembolsados. As sobretaxas para os períodos de inscrição não serão reembolsadas, indiferente da duração do período de inscrição.
		Você concorda que os Serviços começarão assim que nós lhe enviarmos o e-mail de confirmação de sua inscrição.
		Condições Gerais de Uso
		<br><br>
		O Site reserva o direito de fazer alterações e / ou melhorias a qualquer momento à informação contida no Site ou às configurações do Site a qualquer momento e sem aviso prévio, que serão sujeitas às condições estabelecidas nestes Termos e Condições Legais.
		<br><br>
		Em particular, ele reserva o direito de alterar unilateralmente, sem aviso prévio, a apresentação, configuração e o conteúdo do Site, e dos Serviços oferecidos, assim como as suas regras de funcionamento e estes Termos e Condições Legais, atuando sempre de acordo com a legislação de implementação, e desde que haja causa suficiente para tal.
		<br><br>
		No evento em que hajam alterações, elas seriam comunicadas através do própria Site ou de acordo com os meios determinados mais efetivos para o conhecimento geral dos Usuários, e seriam efetuadas para a melhoria e a atualização do funcionamento.
		<br><br>
		Quaisquer modificações serão efetuadas imediatamente após a data de sua publicação no site.
		<br><br>
		O Usuário concorda usar corretamente a Web de acordo com a lei e com o aviso legal, a moral e a ordem pública presente. O Usuário responderá ao Site ou a partes terceiras por quaisquer danos que possam ser causados como resultado da violação de tal obrigação.
		<br><br>
		O acesso, a navegação e o uso do Site é de responsabilidade do Usuário e ele/ela promete usar os conteúdos diligentemente, corretamente e de acordo com a lei, assim como respeitar fielmente quaisquer instruções adicionais oferecidas pelo www.processflex.com ou pelo pessoal autorizado da Web com respeito ao uso do Site e dos seus conteúdos. O Usuário individualmente compromete-se a evitar efetuar o seguinte, mas não somente limitado ao seguinte:
		<br><br>
		Usar os conteúdos para fins ou ações contrárias às lei, morais e aos bons costumes geralmente aceitos, ou à ordem pública. Para este fim, o Site reserva o direito de prevenir ou proibir o acesso a qualquer Usuário da Internet que introduza neste Site qualquer conteúdo contrário à Web ou aos regulamentos de moral, também reservando o direito de efetuar todas as medidas legais que podem corresponder para evitar este tipo de conduta.
		<br><br>
		Reproduzir, copiar, distribuir ou permitir acesso público através de qualquer forma de comunicação pública; Alterar, mudar, modificar ou adaptar os conteúdos, a não ser que autorizado pelo detentor dos direitos correspondentes ou legalmente permitidos.
		<br><br>
		Usar conteúdos e, em particular, informação de qualquer tipo obtida através da Web ou de seus serviços para enviar publicidade, comunicações com o propósito de venda direta ou usá-la para qualquer outro tipo de fim comercial, promocional ou de envio de mensagens (incluindo qualquer tipo de ‘e-mail malicioso’, ‘spam’, ‘corrente’, ‘esquema de pirâmide’ ou semelhante), assim como comercializar ou publicar tal informação de qualquer outra forma.
		<br><br>
		Efetuar qualquer ato contrário às normas que regulam a proteção dos dados pessoais, do mercado e dos consumidores, da propriedade intelectual, das regras fiscais, que regulam a proteção à honra, da privacidade, e da imagem e reputação das pessoas ou das entidades.
		<br><br>
		Realizar qualquer ato de difamação, abuso ou agressão, assédio, ameaça e / ou fraude de qualquer tipo; assim como qualquer ato ou atividade que é considerada ou pode ser considerada obscena, indecente, pornográfica ou relacionada à pornografia, ou de qualquer outro modo ofensiva.
		<br><br>
		Realizar qualquer atividade que pode dar início à responsabilidade civil ou criminal, que incentiva o comportamento punível por lei, ou incentiva ou promove atividades ilegais tais como o ‘hacking’, ‘cracking’ ou ‘phreaking’.
		<br><br>
		Introduzir através de quaisquer meios elementos tais como vírus, malwares, Trojans, ‘ovos de páscoa’, ‘bombas relógio’, spyware, ou outros softwares, códigos ou arquivos que podem ser maliciosos, perigosos ou invasivos, ou que podem causar danos ou o uso mal intencionado das operações do Site, ou monitorar ou controlar o uso de qualquer tipo de hardware, software ou equipamento.
		<br><br>
		Usar qualquer aplicativo robô, ‘spider’, de busca ou de coleta de dados na Web, ou instalar ou usar qualquer dispositivo automático ou manual para coletar, indexar, extrair, fazer ‘mineração de dados’ ou de qualquer outra forma coletar ou armazenar o conteúdo da Web, ou reproduzir ou burlar a estrutura de navegação ou a apresentação da Web sem consentimento prévio do www.processflex.com.
		<br><br>
		O uso da Web para fins prejudiciais ao www.processflex.com, à sua propriedade ou aos seus interesses, ou a partes terceiras é expressamente proibido, ou usar de qualquer forma que sobrecarregue, danifique ou torne as redes, os servidores e outros tipos de hardware, ou os produtos e aplicativos (Softwares), o Site ou as partes terceiras inutilizáveis.
		<br><br>
		Os Usuários e, em geral, qualquer pessoa que acesse a Web através de qualquer canal, deve se recusar a obter, ou tentar obter qualquer tipo de material acessível através da própria Web, ou dos serviços oferecidos pela Web, com o uso de meios ou procedimentos diferentes dos que estão disponíveis para tais fins.
		<br><br>
		Responsabilidades e Obrigações
		<br><br>
		A informação oferecida e gerenciada pelo Usuário é confidencial e está sujeita ao sigilo profissional. O Site tratará a informação de seus Usuários de acordo com as regras de proteção de dados pessoais vigentes em Portugal e na União Europeia,em particular a Diretiva 95/46 / CE do Parlamento Europeu e do Conselho Europeu, de 24 de Outubro de 1995 sobre a proteção de indivíduos com respeito ao processamento de dados pessoais e sobre o movimento livre de tais dados e o Regulamento (UE) 2016/679 do Parlamento Europeu e do Conselho Europeu, de 27 de Abril de 2016, sobre a proteção de indivíduos com respeito ao processamento de dados pessoais e sobre o movimento livre de tais dados, revogando a Diretiva 95/46 / CE.
		<br><br>
		O Site garante aplicar as medidas de segurança adequadas, adaptadas aos regulamentos atuais, planejadas para proteger a confidencialidade, segurança, integridade, e a vericidade da informação oferecida neste Site e não assumirá qualquer responsabilidade por quaisquer danos, prejuízos ou perdas tangíveis ou intangíveis resultante do uso fraudulento dos conteúdos do Site, ou do seu próprio uso ou acesso ao Site, incluindo quaisquer conexões que possam ter sido feitas através desse site ou do mal-uso de senhas ou identificadores usados para acessar os conteúdos do mesmo.
		<br><br>
		Após o término da relação legal estabelecida com o Usuário, a Web está inteiramente comprometida a prevenir o acesso a quaisquer dados e informações em sua posse. A preservação de quaisquer dados ou informações que sejam acessados em virtude dos serviços oferecidos na Web após o término de tais serviços está expressamente proibido, independente do dever de conservação requerido pelas provisões legais aplicáveis.
		<br><br>
		O Site garante realizar a manutenção de todas as condições de funcionamento necessárias, das atualizações, das melhorias, da disponibilidade e da segurança da Web, assim como das condições necessárias para resolver qualquer tipo de incidente ou consulta derivada dos Serviços, e daquelas que podem ser necessárias para garantir a integridade dos mecanismos de autenticação e identificação necessários.
		<br><br>
		A Web e os Serviços realizados através dela, devem ser usados exclusivamente como uma ferramenta de armazenamento, consulta e gerenciamento dos Serviços oferecidos, com o Site se tornando isento de qualquer responsabilidade relativa ao mal-uso da plataforma ou de fins contrários aos mencionados.
		<br><br>
		O Site não será responsável pela veracidade ou a legalidade de quaisquer Documentos armazenados pelos Usuários, nem pelo seu uso através da Web. O Site não garante a qualidade ou a adequação dos arquivos enviados, consultados ou armazenados que serão de qualquer maneira responsabilidade do Usuário, e não deve ser responsável por danos diretos, indiretos, consequentes ou incidentes de usos não-atribuíveis.
		<br><br>
		O Site não é responsável por danos de qualquer natureza que possam resultar de falhas técnicas ou na disponibilidade do Site. Em particular, o www.processflex.com não é responsável nem garante que o acesso a este Site será ininterrupto ou livre de erros. Em nenhum caso o Site será responsável por perdas, danos ou prejuízos de nenhum tipo resultantes do acesso e do uso do Site, incluindo, mas não limitado, àqueles causados aos sistemas de computadores ou àqueles causados pela introdução de um vírus.
		<br><br>
		Neste sentido, a Web não deve ser legalmente responsável de nenhuma forma por (a) interrupções em suas atividades comerciais; (b) atrasos ou interrupções no acesso à Web; (c) falhas de entrega, entregas errôneas, corrupções, destruições ou alterações de dados; (d) danos causados ao equipamento computacional dos Usuários ou de partes terceiras durante o oferecimento do serviço da Web e (e) quaisquer outros incidentes que estão além do controle razoável do Site. O Site não será responsável por danos ou perdas causadas pelas decisões tomadas e baseadas na informação divulgada por este meio nem por quaisquer possíveis imprecisões, omissões ou erros contidos nela. A Web não é responsável por danos e perdas de qualquer natureza que possam ser derivadas do conhecimento não autorizado de partes terceiras aos dados do Usuário e ao seu uso do Site.
		<br><br>
		Serviço ao Cliente
		<br><br>
		O www.processflex.com possui um Serviço de Suporte ao Usuário para garantir os Serviços do Site e para tratar de resolver possíveis incidentes que possam ser causados, que pode ser contatado através do endereço de e-mail info@onlinecurriulo.com.
		<br><br>
		Política de Links
		<br><br>
		O Site não é responsável de qualquer forma pelos conteúdos de sites nos quais possam ter sido mencionados em links no Site. De forma semelhante, a Web não pode ser mantida como responsável pelo resultado obtido através destes links ou pelas consequências derivadas do acesso dos Usuários aos mesmos.
		<br><br>
		O Site será apenas responsável pelo conteúdo e pelos Serviços oferecidos nos Sites mencionados em links no www.processflex.com na medida em que a Web tenha conhecimento real de sua ilegalidade.
		<br><br>
		No evento em que um Usuário possa suspeitar de uma possível violação das condições de confidencialidade estabelecidas na Web, o Usuário deve entrar em contato com a Web assim que possível para minimizar os possíveis efeitos negativos que podem resultar de tal situação. O Site não deve ser responsável por quaisquer perdas ou danos que podem resultar do evento em que tais suspeitas não sejam comunicadas através da maneira indicada.
		<br><br>
		Propriedade Intelectual e Industrial
		<br><br>
		A aceitação destes Termos e Condições Legais pelo Usuário implica uma licença para usar as ferramentas da Web, que terá caráter exclusivo ou não-transferível, e que permitirá o uso e o acesso aos Serviços oferecidos por www.processflex.com em qualquer parte do mundo.
		<br><br>
		De forma semelhante, o Site inteiro, isto é, os elementos que ele contém (textos, imagens, marcas registradas, logomarcas, arquivos de áudio, arquivos de software, combinações de cores, etc.), assim como a estrutura, a seleção e a ordem dos seus Conteúdos são protegidos pelas regras de Propriedade Intelectual e Industrial vigentes na Espanha e em países em que ele é usado, e não podem ser explorados, reproduzidos, distribuídos, alterados, publicamente transferidos, transferidos, transformados ou divulgados de qualquer outra forma não expressamente autorizada.
		<br><br>
		O acesso ao Site não concede aos Usuários nenhum direito ou posse alguma sobre os direitos de propriedade intelectual e / ou industrial do conteúdo que ele contém.
		<br><br>
		Os textos e elementos gráficos (design, logomarcas, código fonte e semelhantes) assim como os conteúdos, imagens, marcas registradas, logomarcas, etc. que aparecem nestas páginas, e também a sua apresentação e montagem, são propriedade exclusiva do Site, que detém todos os direitos de propriedade intelectual e industrial sobre os mesmos, incluindo o software. O acesso a este material não implica de forma alguma o concedimento de uma licença para a sua reprodução e / ou distribuição, que em nenhum caso está permitida sem o consentimento prévio da Web, mesmo que a origem da mesma esteja detalhada. O Site reserva o direito de exercer quaisquer ações judiciais que podem corresponder ao mesmo de acordo com os regulamentos de aplicação contra os Usuários que violarem ou infringirem de qualquer forma os direitos de propriedade intelectual e industrial derivadas da Web.
		<br><br>
		Posse de Informação
		<br><br>
		O Usuário é o proprietário único dos Documentos que ele/ela incorpora, edita, modifica, gerencia ou armazena no Site, portanto o acesso ao mesmo por partes terceiras que não o Usuário, será efetuado sob supervisão e responsabilidade exclusiva do Usuário. Em todos os casos, o Usuário reconhece a legalidade de toda a informação usada ou divulgada na Web, expressamente isentando o www.processflex.com, a Empresa, ou os fornecedores de seus serviços, ou os parceiros de negócios de qualquer responsabilidade resultante da possível ilegalidade de tal informação, e o infringimento de direitos de partes terceiras.
		<br><br>
		O Usuário pode a qualquer momento baixar os Documentos da Web de acordo com as funcionalidades do Site, e possuirá um direito de reversão como um meio em que ele pode solicitar o cancelamento do serviço e o download, por 14 dias, de todos os Documentos armazenados até a data na Web, garantindo a eliminação de toda a informação assim que o serviço for revertido.
		<br><br>
		Cookies
		<br><br>
		Para obter estatísticas a respeito do número de visitantes à Web, o CllFlex fará uso de informações não identificáveis relacionadas aos visitantes.
		O uso da Web pode gerar ‘cookies’, entendidos como fragmentos de informação armazenados no disco rígido do computador do Usuário, e que podem ser usados para melhorar a operação do Site em visitas futuras e oferecer um melhor serviço ao Usuário. O Usuário possui a possibilidade de rejeitar o uso de cookies em seu computador. Ele/Ela pode fazer isso ao ajustar as configurações de seu navegador.
		<br><br>
		Jurisdição e Legislação Aplicável
		<br><br>
		Os presentes Termos e Condições Legais serão governados, interpretados e executados de acordo com os regulamentos Portugueses, renunciando a própria jurisdição do Usuário e submetendo-se à jurisdição e local dos Tribunais e Cortes de Lisboa (Portugal), a despeito de qualquer provisão legal ao contrário.
		<br><br>
		Ao usar os Serviços de diferentes locais, os Usuários assumem tal uso sob a sua responsabilidade e sob o seu próprio risco. Os Usuários devem cumprir com os regulamentos estabelecidos nos locais onde eles estão localizados e de onde eles acessam os Serviços como aplicável.
		<br><br>
		Termos de Validade
		<br><br>
		Estes Termos e Condições Legais se aplicarão por tempo indeterminado até que o Site determine o seu término. A web pode, à sua discrição, terminar o acesso ou o uso do Site de acordo com os regulamentos aplicáveis, incluindo a situação em que os Usuários podem ter violado ou agido inconsistentemente com estes Termos e Condições Legais. Seguido o término da Web, os direitos do Usuário cessarão imediatamente, o Site sendo capaz de desativar os nomes de usuário e senhas atribuídos, ou excluí-los, junto com qualquer informação e / ou documentação associada e de acordo com os regulamentos da aplicação.
		<br><br>
		O Cllflex junto de quaisquer marcas, entidades e organizações associadas não assumirão qualquer responsabilidade pelo término do uso do Site e / ou dos Serviços além das econômicas que podem surgir com a contratação dos Serviços, de acordo com os termos das políticas de cancelamento e reembolso do Site.
		<br><br>
		Solução de Disputas
		<br><br>
		Antes de iniciar qualquer procedimento ou intermediação ou arbitragem, os Usuários devem entrar em contato com o Site através do e-mail suport@cllflex.com  para tentar alcançar uma solução entre as partes.
		<br><br>
		Reclamações a respeito do Serviço serão tratadas em dentro de 14 dias úteis do recebimento do aviso por e-mail enviado a suport@cllflex.com ou ao escrever para o endereço. No evento em que a reclamação seja aceita pela Web, o Usuário possuirá o direito de usar os Serviços de acordo com os termos acordados, ou será reembolsado o preço pago por tais Serviços.	
	`,
  policy: `
		Política de Privacidade CllFlex<br><br>
		Partes Envolvidas<br><br>
		CllFlex: Sistema computacional de gestão no qual empresas ou pessoas singulares podem criar contas para gestão de suas atividades, como cadastro e gestão de perfis. É responsável pelo CllFlex seu desenvolvedor e mantenedor.
		Detentora da Conta ou Detentor da Conta: Entendida como a empresa ou pessoa singular que cria uma conta no sistema com o objetivo de cadastrar e disponibilizar o cadastro de perfis no sistema. Além do cadastro de Perfis', ela terá disponível outros recursos para gestão das suas atividades. A identificação da Detentora da conta é de única responsabilidade do indivíduo que realiza o cadastro da mesma, não sendo atestado nem garantido pela CllFlex;
		Perfis: Cadastro de pessoas singulares ou empresa. O cadastro de perfis podem assumir tipos diferentes, como Candidatos, Fornecedores, Empregados, etc. A Detentora da Conta poderá realizar o cadastro dos perfis diretamente na conta ou disponibilizar ou enviar link para o cadastro pelo próprio proprietário do perfil.
		Proprietário do Pefil: pessoa singular ou empresa detentora real dos dados pessoais ou empresariais inseridos no perfil.
		<br><br>
		Considerações: <br>
		Os perfis inseridos em uma determinada conta no sistema não é compartilhado com as demais contas. Cada Detentor de Conta possui seus próprios Perfis', registrados, separados de forma exclusiva e restrita apenas aos seus próprios usuário;
		Ao criar um perfil através do acesso por link externo, será criado um usuário de perfil na conta que originou o link de cadastro.
		<br><br>
		Introdução
		A CllFlex é responsável apenas pelo armazenamento dos dados dos perfis  em seus servidores e a disponibilização dos mesmos pelo seu sistema à Detentora da Conta, mas, em momento algum, utilizará os mesmos e nunca fará qualquer qualquer compartilhamento com quem quer que seja, excluídos os caso de mero uso para manutenção do sistema. Os seus dados estarão disponíveis para usuários da conta no sistema pertencente Detentora da Conta, a qual será a responsável pela sua utilização em seus próprios termos de uso e privacidade aos quais o sistema CllFlex não é responsável nem autor.
		<br>
		As informações que recolhemos
		<br><br>
		As informações recolhidas no formulário de cadastro é definida pela configuração de perfis no sistema e é de responsabilidade da Detentora da Conta. Os dados dos perfis serão armazenadas em servidores de base de dados.
		<br><br>
		A Base Legal para o Tratamento dos seus Dados Pessoais
		<br><br>
		Ao abrigo do RGPD, os principais motivos em que nos apoiamos relativamente ao tratamento das informações pessoais dos clientes e dos candidatos são os seguintes:
		<br><br>
		(a) Necessidade de manutenção do sistema  – A única utilização possível pela CllFlex dos dados dos perfis cadastrados são apenas para a manutenção do sistema, sem qualquer compartilhamento ou uso individual dos dados, sendo tratados apenas como registros em base de dados sem qualquer valor ou interesse nas informações relativas à cada registro.;
		<br><br>
		(b) Necessário para o cumprimento de uma obrigação legal – estamos sujeitos a determinados requisitos legais que possam exigir que efetuemos o tratamento dos seus dados pessoais. Podemos também ser obrigados, por lei, a divulgar os seus dados pessoais a uma entidade reguladora ou a um serviço de aplicação da lei;
		<br><br>
		(d) Consentimento – em algumas circunstâncias, podemos solicitar o seu consentimento para efetuar o tratamento dos seus dados pessoais de uma forma específica.
		<br><br>
		Por quanto tempo manteremos as suas informações
		<br><br>
		O período de tempo em que deteremos ou armazenaremos as suas informações pessoais dependerá dos Detentora da Conta.  Caso a Detentora da Conta recuse-se a excluir os dados quando solicitado pelo proprietário do perfil, o Proprietário do Perfil poderá solicitar (com a devida identificação) a exclusão diretamente pela CllFlex. Em um primeiro momento, a CllFlex fará a requisição à Detentora da Conta e, caso essa não proceda a devida exclusão, a CllFlex poderá realizar a ação diretamente, mediante confirmação formal e apresentação de documentação de identificação legalmente válida.
		<br>
		Informações agregadas sobre os visitantes online das Companhias
		<br>
		Recolhemos informações e estatísticas de forma coletiva sobre todos os visitantes do nosso sítio Web e dos sítios Web de todas as empresas do Grupo:
		<br><br>
		Quais as áreas a que os utilizadores acedem com mais frequência; e/ou
		Quais os serviços a que os utilizadores acedem com mais frequência.
		<br><br>
		Utilizamos apenas tais dados de forma agregada. Essas informações ajudam-nos a determinar o que é mais vantajoso para os nossos utilizadores e a forma como podemos melhorar continuamente os nossos serviços online para criar uma experiência geral melhor para os nossos utilizadores.
		<br><br>
		Publicamos também essas informações nos sítios Web das empresas do Grupo de empresas as Companhias a nível mundial.
		<br><br>
		Utilizamos o Hotjar para compreendermos melhor as necessidades dos nossos utilizadores e otimizarmos o nosso serviço e a sua experiência. O Hotjar é um serviço de tecnologia que nos ajuda a compreender melhor a experiência dos nossos utilizadores (por ex. o tempo que despendem em quais páginas, quais os links em que clicam, o que os utilizadores gostam e não gostam, etc.) e isso permite-nos desenvolver e manter o nosso serviço com o feedback dos nossos utilizadores. O Hotjar utiliza cookies e outras tecnologias para recolher dados sobre o comportamento dos nossos utilizadores e seus dispositivos (especificamente o endereço IP do dispositivo (captado e armazenado apenas de forma anónima), tamanho do ecrã do dispositivo, tipo de dispositivo (identificadores exclusivos do dispositivo), informações do navegador, localização geográfica (apenas o país), língua preferida utilizada para apresentar o nosso sítio Web). O Hotjar armazena estas informações num perfil de utilizador sob um pseudónimo. Nem o Hotjar nem nós jamais utilizaremos estas informações para identificar utilizadores individuais ou para combiná-las com os dados adicionais de um utilizador individual.
		<br><br>
		Utilização de Cookies
		<br><br>
		Tal como na maioria dos sítios Web, quando visita os nossos sítios, colocamos cookies no seu computador ou outro dispositivo. Na maior parte, estes cookies são utilizados para permitir a funcionalidade dos sítios Web, melhorar a experiência do utilizador e ajudar-nos a otimizar os nossos sítios Web, medir o tráfego e outras finalidades de gestão interna.
		<br><br>
		Realizamos publicidade direcionada e de banner pertinente em diversos sítios Web de lista branca a nível mundial para lhe apresentar postos de trabalho e conteúdo que consideramos que sejam do seu interesse. Direcionamos estes anúncios com base nas suas interações anteriores com o nosso sítio Web, com os nossos emails e por meio das suas comunicações com os nossos consultores. A sua interação com a nossa publicidade poderá ser utilizada para medir a eficácia das nossas campanhas publicitárias e para melhorar a nossa estratégia de marketing, de acordo com os nossos interesses legítimos. Nenhuma campanha de publicidade ou tecnologia de rastreamento de publicidade regista as suas informações pessoalmente identificáveis.
		<br><br>
		Reclamações
		<br><br>
		Se não estiver satisfeito com a utilização da nossa parte das suas informações pessoais, pode contactar-nos utilizando os dados na secção de contacto do site. Tem também o direito de apresentar uma queixa junto do Autoridade de Proteção de Dados utilizando qualquer um dos métodos de contacto infra:
		<br><br>
		Telefone: +351 924402025
		<br>
		Sítio Web: https://www.cnpd.pt/
		<br>
		Correio: Comissão Nacional de Protecção de Dados - CNPD
		<br>
		R. de São. Bento, 148-3°
		1200-821 Lisboa
		<br>
		Se viver ou trabalhar fora do Portugal, ou tiver uma queixa em relação às nossas atividades fora do Portugal, poderá preferir apresentar uma queixa junto de outra autoridade supervisora. Pode aceder aqui a uma lista das autoridades pertinentes no EEE e na Zona de Comércio Livre Europeia.
	`,
};

export default en;
